<template>
  <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle">
    <account-expired-alert></account-expired-alert>
    <offline-alert></offline-alert>
    <verify-alert></verify-alert>
    <enable-conversation-summary-alert v-if="$route.name === 'conversation-summary'" ></enable-conversation-summary-alert>
    <b-row
      v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
      class="content-header"
    >
      <!-- Content Left -->
      <b-col class="content-header-left mb-2" cols="12" md="9">
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h2 class="content-header-title float-left pr-1 mb-0">
              {{ $t($route.meta.pageTitle) }}
            </h2>
            <div class="breadcrumb-wrapper">
              <b-breadcrumb>
                <b-breadcrumb-item to="/">
                  <feather-icon
                    icon="PieChartIcon"
                    size="16"
                    class="align-text-top"
                  />
                </b-breadcrumb-item>
                <b-breadcrumb-item
                  v-for="item in $route.meta.breadcrumb"
                  :key="item.text"
                  :active="item.active"
                  :to="item.to"
                >
                  {{ $t(item.text) }}
                </b-breadcrumb-item>
              </b-breadcrumb>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import VerifyAlert from "@/components/VerifyAlert.vue";
import OfflineAlert from "@/components/OfflineAlert.vue";
import AccountExpiredAlert from "@/components/AccountExpiredAlert.vue";
import EnableConversationSummaryAlert from "@/components/EnableConversationSummaryAlert.vue";

export default {
  directives: {
    Ripple,
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,

    VerifyAlert,
    OfflineAlert,
    AccountExpiredAlert,
    EnableConversationSummaryAlert
  },
};
</script>
